var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5214_20389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.896484,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5214_20389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 14.2301V12.8968H4.50033L4.23366 12.6635C3.65588 12.1524 3.25033 11.569 3.01699 10.9135C2.78366 10.2579 2.66699 9.59681 2.66699 8.93014C2.66699 7.69681 3.03644 6.59959 3.77533 5.63848C4.51421 4.67737 5.4781 4.04125 6.66699 3.73014V5.13014C5.86699 5.41903 5.22255 5.9107 4.73366 6.60514C4.24477 7.29959 4.00033 8.07459 4.00033 8.93014C4.00033 9.43014 4.09477 9.91625 4.28366 10.3885C4.47255 10.8607 4.76699 11.2968 5.16699 11.6968L5.33366 11.8635V10.2301H6.66699V14.2301H2.66699ZM9.33366 14.0635V12.6635C10.1337 12.3746 10.7781 11.8829 11.267 11.1885C11.7559 10.494 12.0003 9.71903 12.0003 8.86348C12.0003 8.36348 11.9059 7.87737 11.717 7.40514C11.5281 6.93292 11.2337 6.49681 10.8337 6.09681L10.667 5.93014V7.56348H9.33366V3.56348H13.3337V4.89681H11.5003L11.767 5.13014C12.3114 5.67459 12.7087 6.26625 12.9587 6.90514C13.2087 7.54403 13.3337 8.19681 13.3337 8.86348C13.3337 10.0968 12.9642 11.194 12.2253 12.1551C11.4864 13.1163 10.5225 13.7524 9.33366 14.0635Z",
    fill: "#004EA8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.ebacf8a07313a775d9882dbc29406985.svg";
export { ForwardRef as ReactComponent };